import * as React from "react";
import { cn } from "@/lib/utils";

interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  tone?: "default" | "amber" | "green" | "red" | "blue" | "violet";
}

const tones: Record<NonNullable<BadgeProps["tone"]>, string> = {
  default: "bg-[#22262f] text-[#e2e8f0] border-[#2a2f3a]",
  amber: "bg-amber/15 text-amber-soft border-amber/40",
  green: "bg-emerald-900/40 text-emerald-300 border-emerald-700/50",
  red: "bg-red-900/40 text-red-300 border-red-700/50",
  blue: "bg-sky-900/40 text-sky-300 border-sky-700/50",
  violet: "bg-violet-900/40 text-violet-300 border-violet-700/50",
};

export function Badge({ className, tone = "default", ...rest }: BadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-medium",
        tones[tone],
        className,
      )}
      {...rest}
    />
  );
}
